const getComponentName = () => {
  try {
    const stack = new Error().stack;
    const callerLine = stack.split('\n')[3]; // Get the caller's line
    const match = callerLine.match(/at\s+(\w+)\s+\(/);
    return match ? match[1] : 'Unknown';
  } catch (e) {
    return 'Unknown';
  }
};

const logger = {
    log: (...args) => {
      if (process.env.NODE_ENV !== 'production') {
        const componentName = getComponentName();
        console.log(`[${componentName}]`, ...args);
      }
    },
    logAlways: (...args) => {
      // This will log regardless of environment
      const componentName = getComponentName();
      console.log(`[${componentName}]`, ...args);
    },
    error: (...args) => {
      // You might want to keep error logs even in production
      const componentName = getComponentName();
      console.error(`[${componentName}]`, ...args);
    }
  };
  
  export default logger;